import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Resets the window scroll position on every route change. */
export default function useScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}
